import React from 'react'
import { Card, CardContent, Grid, Typography } from '@material-ui/core'

const CustomCard = (props) => {
  return (
    <Card elevation={4}>
      <CardContent>
        <Grid container direction='column' alignItems='center'>
          <Grid item>
            <Typography
              align='center'
              variant='h4'
              color='textSecondary'
              gutterBottom
              noWrap={true}
            >
              {props.title}
            </Typography>
          </Grid>
          <Grid item>{props.icon}</Grid>
          <Grid item>
            <Typography
              align='center'
              variant='h5'
              color='textSecondary'
              gutterBottom
            >
              {Math.floor(Math.random() * 1000)}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default CustomCard
